module.exports = __webpack_public_path__ + "img/sh_tw-y.69a2d3ef.svg";